<template>
  <el-dialog :title="diglogTitle" :visible="value" width="1020px" @close="closeDialog" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false">
    <el-form class="el-form-edit" ref="tableForm" :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
      <el-form-item :label="$lang('姓名')" prop="name" class="myDetailItem">
        <el-input v-model="rowData.name" :minlength="1" :maxlength="60" :placeholder="$lang('请填写寄件人姓名')"></el-input>
      </el-form-item>
      <el-form-item class="area-code" label-width="50px" :label="$lang('区号')">
        <el-button plain>+52</el-button>
      </el-form-item>
      <el-form-item :label="$lang('联系电话')" prop="mobile" class="myDetailItem">
        <el-input v-model="rowData.mobile" :maxlength="10" :placeholder="$lang('请填写寄件人联系电话')"></el-input>
      </el-form-item>
      <el-form-item :label="$lang('公司名称')" prop="companyName" class="myDetailItem">
        <el-input v-model="rowData.companyName" :maxlength="256" :placeholder="$lang('请填写寄件人公司名称')"></el-input>
      </el-form-item>
      <el-form-item :label="$lang('邮编')" id="areaCodeSty" prop="postalCode">
        <el-input @blur="postalCodeChange(rowData.postalCode, 3, 1)" v-model.trim="rowData.postalCode" :minlength="1" :maxlength="5"></el-input>
      </el-form-item>
      <el-form-item :label="$lang('州')" prop="provinceName">
        <el-input v-model.trim="rowData.provinceName" readonly disabled></el-input>
      </el-form-item>
      <el-form-item :label="$lang('市')" prop="cityName">
        <el-input v-model.trim="rowData.cityName" readonly disabled></el-input>
      </el-form-item>
      <el-form-item :label="$lang('乡镇')" prop="areaName">
        <el-select v-model="rowData.areaName" @change="dataAreaChange($event, 3)">
          <el-option v-for="item in areaList2" :key="item.id" :label="item.nativeName" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$lang('邮箱')" id="areaCodeSty" prop="email">
        <el-input v-model.trim="rowData.email" :minlength="1" :maxlength="60"></el-input>
      </el-form-item>
      <div>
        <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
          <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1" :maxlength="256"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('详细地址2')" prop="detailedAddress2" class="addressDeatil">
          <el-input v-model="rowData.detailedAddress2" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1" :maxlength="256"></el-input>
        </el-form-item>
      </div>
      <el-form-item :label="$lang('设为默认')" prop="isDefault">
        <el-switch v-model="rowData.isDefault" active-value="1" inactive-value="2" active-color="#13ce66" inactive-color="#ddd"> </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading" @click="handleSubmitBefore" class="h40 h104">{{ $lang('保存') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import { RULES, phoneAndMobile } from '@utils/rules'
import address from '@/mixins/address'
import * as Api from '@api/base/public'
import { addAddress } from '@api/module/customer'

export default {
  name: 'Address',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [address],

  data() {
    return {
      diglogTitle: this.$lang('新增寄件地址'),
      rowData: {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        detailedAddress: '',
        isDefault: '2', // 是否设置为默认地址 1设置默认地址 2 不设置
        type: 1,
        id: '',
        companyName: '',
        postalCode: '',
        email: '',
        mobileAreaCode: '+52',
        detailedAddress2: '',
      },
      rules: {
        name: [RULES.requiredTrim, RULES.senderName],
        mobile: [RULES.requiredTrim, { validator: phoneAndMobile }],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.required, RULES.senderCompany],
        companyName: [RULES.senderCompany],
        email: [RULES.email],
        postalCode: [RULES.required, RULES.postalCode],
        detailedAddress2: [RULES.senderCompany],
        areaName: [RULES.requiredSelect],
      },
      loading: false,
    }
  },
  methods: {
    closeDialog() {
      this.$refs.tableForm.resetFields()
      this.$emit('input', false)
    },
    // 表单保存前
    async handleSubmitBefore() {
      // 表单保存前校验邮编
      const { postalCode } = this.rowData
      const { code, data, msg } = await Api.getSelectByZipCode({ zipCode: postalCode })
      if (code === RESPONSE_SUCCESS && data) {
        this.$refs.tableForm.validate((valid) => {
          if (!valid) return
          this.submit()
        })
      } else {
        this.$message.error(msg)
        return false
      }
    },
    async submit() {
      try {
        const params = {
          ...this.rowData,
        }
        this.loading = true
        const { code, msg } = await addAddress(params)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('保存成功'))
          this.$emit('input', false)
          this.$emit('success')
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.myDetail {
  display: inline-flex;
  padding: 0 0 24px 0;
  .myDetailItem {
    width: 200px;
    padding: 0 8px;
    .myDetailItemText {
      padding-bottom: 4px;
    }
  }
}
.addressDeatil {
  ::v-deep .el-input {
    width: 360px !important;
  }
}
::v-deep .el-dialog__header {
  padding: 12px 25px !important;
  border-bottom: 1px solid #eeeeee;
}
</style>
